var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDonut = function SvgDonut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 304,
    height: 304,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F8F9",
    d: "M304 152c0 83.947-68.053 152-152 152S0 235.947 0 152 68.053 0 152 0s152 68.053 152 152m-258.4 0c0 58.763 47.637 106.4 106.4 106.4 58.763 0 106.4-47.637 106.4-106.4 0-58.763-47.637-106.4-106.4-106.4C93.237 45.6 45.6 93.237 45.6 152"
  })));
};
export { SvgDonut as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMWI2NjQ1ZDNmY2QxZjhhMDZkY2RlM2RkNTNkNTRhNWIuc3ZnIjs=";